import { render, staticRenderFns } from "./OrderLog.vue?vue&type=template&id=2ff8b008&scoped=true&"
import script from "./OrderLog.vue?vue&type=script&lang=js&"
export * from "./OrderLog.vue?vue&type=script&lang=js&"
import style0 from "./OrderLog.vue?vue&type=style&index=0&id=2ff8b008&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff8b008",
  null
  
)

export default component.exports